import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const UsersPrimaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)]",
})``;

export const UsersInfoRow = styled.div.attrs({ className: "flex items-center gap-3" })``;

export const UsersThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const UsersLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const UsersMetaText = styled.p.attrs({ className: "text-xs text-[var(--brand-muted)]" })``;

export const UsersGridLayout = styled.div.attrs({
  className: "grid gap-3 md:grid-cols-[1.3fr_0.7fr]",
})``;

export const UsersFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const UsersFieldSelect = styled.select.attrs({ className: "brand-input" })``;
